
import getLicensePlateColor from '../../functions/extensions/lpColors'
import { states } from '../../GlobalVars'

const SizableLicensePlate = ({
    stateAndLicensePlate,
    isMobile,
    context
}) => {

    // LP colors
    const findKeyByValue = (obj, value) => {
        return Object.keys(obj).find(key => obj[key] === value)

    };

    let plateState = stateAndLicensePlate.split('-')[0]
    let licensePlate = stateAndLicensePlate.split('-')[1]

    const key = findKeyByValue(states, plateState)

    const { licensePlateColor, fontColor, fontColor2 } = getLicensePlateColor(plateState);

    return (

        <div>
            <div
                className={`flex flex-col w-[95px] outline outline-[1px] outline-gray-400 rounded-[6px] justify-center items-center ${context === 'expandedTicket' ? 'shadow-gray-300 shadow-md' : (context === 'riskBanner' ? `shadow-red-800 shadow-md` : (context === 'blueBanner' ? 'shadow-lg shadow-blue-700' : 'border-gray-800  shadow-none scale-[0.96]'))} relative`}
                style={{ 
                    height: 43, 
                    backgroundColor: plateState === "" ? '#ffffff' : licensePlateColor,
                    transform: !isMobile ? 'scale(2)' : '',
                    right: !isMobile ? 0 : 0,
                    top: !isMobile ? 0 : 0
                }}
            >

                {/* state */}
                <p
                    className={`font-lpFont text-[9px] scale-y-75 relative top-[3px]`}
                    style={{ color: fontColor2 }}>
                    {(states[plateState]?.toUpperCase())}

                </p>

                {/* plate number */}
                <p
                    className={`font-lpFont text-[21px] relative top-[0px]`}
                    style={{ color: fontColor }}
                >
                    {licensePlate?.toUpperCase()}
                </p>


            </div>
        </div>
    )
}

export default SizableLicensePlate
